import { render, staticRenderFns } from "./VaffMedia.vue?vue&type=template&id=8b644c42&"
import script from "./VaffMedia.vue?vue&type=script&lang=js&"
export * from "./VaffMedia.vue?vue&type=script&lang=js&"
import style0 from "./VaffMedia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports